import React from 'react';
import {
  Text, FontWeight, HStack,
} from '@doveit/bricks';
import { Task } from '../../../providers/api/dtos';
import { setVerticalEllipsis } from '../../../utils/styles/verticalEllipsis.style';
import ViewTaskPopoverPreview from '../../containers/view-task-popover-preview/ViewTaskPopoverPreview';
import TaskAvatar from '../task-avatar/TaskAvatar';

export interface TaskPreviewProps extends React.AriaAttributes {
  task: Task;
}

const TaskPreview: React.FC<TaskPreviewProps> = ({
  task,
  'aria-label': ariaLabel = 'view-task-preview',
  ...rest
}) => (
  <ViewTaskPopoverPreview
    {...rest}
    aria-label={ariaLabel}
    task={task}
    trigger={(
      <HStack gap={100} wrap="nowrap">
        <TaskAvatar size="S" />
        <Text.BodySmall
          aria-label="Titolo attività"
          fontWeight={FontWeight.MEDIUM}
          css={setVerticalEllipsis()}
        >
          {task.title}
        </Text.BodySmall>
      </HStack>
    )}
  />
);

export default TaskPreview;
